import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';

import {setaDropdown} from '../../../utils/alternanciaIcones'
import SelectInput from "../../componentesModais/selects/selectComOpcoesPreConfiguradas";

export default function DivAtivacao({ dsProdutoTelecall, setDsProdutoTelecall, services }) {
    const [revelarSelectProdutoTelecall, setRevelarSelectProdutoTelecall] = useState(false)

  return (
    <>
        <div className="grupo-bloquear-temporariamente-1">
            <div className="coluna-select-iot-telecom-1">
                <Form.Group>
                    {/* <Form.Label> */}
                        {/* <div className="fonte-cor-1 label-campo">Produto</div>  */}
                    {/* </Form.Label> */}
                        <label className='mt-3 fonte-cor-1 campo-texto-titulo-opcoes-ativacao-2'>Produto</label>
                    { revelarSelectProdutoTelecall === false &&
                        <Button name="cdProdutoTelecall" className="campo-texto-cor-3 campo-select" onClick={() => setRevelarSelectProdutoTelecall(!revelarSelectProdutoTelecall)}>
                            <div className="fonte-cor-1 label-campo">{dsProdutoTelecall}</div>
                            <img className="campo-select-icone-desativado" src={setaDropdown()} alt="drop" />
                        </Button>
                    }
                    { revelarSelectProdutoTelecall === true &&
                        <SelectInput
                            setRevelarSelect={setRevelarSelectProdutoTelecall} //Hook para fechar a modal
                            setDs={setDsProdutoTelecall} //Nome do ProdutoTelecall
                            ds={dsProdutoTelecall}
                            options={[
                                { text: 'M01/PRO - M2M-VIR-ESPECIAL', value: 'M01/PRO - M2M-VIR-ESPECIAL'  },
                                { text: 'M01/PRO - M2M-VIR-ESPECIAL VOICE', value: 'M01/PRO - M2M-VIR-ESPECIAL VOICE'  },
                            ]}
                        >
                        </SelectInput>
                    }
                </Form.Group>
            </div> 
        </div> 

        <div className="container-principal-checkbox-selecao-ativacao">
            <label className='fonte-cor-1 campo-texto-titulo-opcoes-ativacao-2'>Serviços</label>
            <div className="container-checkbox-selecao-ativacao">
                <div className="grupo-1-selecao-ativacao">
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="entradaSmsBloqueada" name="entradaSmsBloqueada" onChange={(e) => services.setEntradaSmsBloqueada(e.target.checked)}/>
                        <label htmlFor="entradaSmsBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear entrada de SMS</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="saidaSmsBloqueada" name="saidaSmsBloqueada" onChange={(e) => services.setSaidaSmsBloqueada(e.target.checked)}/>
                        <label htmlFor="saidaSmsBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear saída de SMS</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="servicoGprsBloqueado" name="servicoGprsBloqueado" onChange={(e) => services.setServicoGprsBloqueado(e.target.checked)}/>
                        <label htmlFor="servicoGprsBloqueado" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">bloquear serviço de GPRS</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="chamadaRecebidaBloqueada" name="chamadaRecebidaBloqueada" onChange={(e) => services.setChamadaRecebidaBloqueada(e.target.checked)}/>
                        <label htmlFor="chamadaRecebidaBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear chamada recebida</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="chamadaRecebidaEmRoamingBloqueada" name="chamadaRecebidaEmRoamingBloqueada" onChange={(e) => services.setChamadaRecebidaEmRoamingBloqueada(e.target.checked)}/>
                        <label htmlFor="chamadaRecebidaEmRoamingBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear chamada recebida em roaming</label>
                    </div>
                </div>
                <div className="grupo-1-selecao-ativacao">
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="chamadaEfetuadasBloqueada" name="chamadaEfetuadasBloqueada" onChange={(e) => services.setChamadaEfetuadasBloqueada(e.target.checked)}/>
                        <label htmlFor="chamadaEfetuadasBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear chamadas efetuadas</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="chamadaInternacionalBloqueada" name="chamadaInternacionalBloqueada" onChange={(e) => services.setChamadaInternacionalBloqueada(e.target.checked)}/>
                        <label htmlFor="chamadaInternacionalBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear chamadas internacionais</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="chamadaInternacionalEmRoamingBloqueada" name="chamadaInternacionalEmRoamingBloqueada" onChange={(e) => services.setChamadaInternacionalEmRoamingBloqueada(e.target.checked)}/>
                        <label htmlFor="chamadaInternacionalEmRoamingBloqueada" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear chamadas internacionais em roaming, <br/> exceto para o país de origem do assinante</label>
                    </div>
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="todasChamadasEmRoamingBloqueadas" name="todasChamadasEmRoamingBloqueadas" onChange={(e) => services.setTodasChamadasEmRoamingBloqueadas(e.target.checked)}/>
                        <label htmlFor="todasChamadasEmRoamingBloqueadas" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear todas as chamadas feitas em roaming</label> 
                    </div>
                </div>
            </div>
        </div>

        <div className="container-principal-checkbox-selecao-ativacao">
            <label className='fonte-cor-1 campo-texto-titulo-opcoes-ativacao-2'>Bloqueio</label>
            <div className="container-checkbox-selecao-ativacao">
                <div className="grupo-1-selecao-ativacao">
                    <div className="checkbox-selecao-ativacao">
                        <input type='checkbox' className="input-checkbox-header-simcard" id="bloqueioDeLinha" name="bloqueioDeLinha" onChange={(e) => services.setBloquearLinha(e.target.checked)}/>
                        <label htmlFor="bloqueioDeLinha" className="label-checkbox-ativacao"></label>
                        <label className="campo-texto-selecao-ativacao fonte-cor-1">Bloquear linha</label>
                    </div>
                </div>
            </div>
        </div>
    </>
)
}